import React from 'react';
import Cookies from 'universal-cookie';
import { TableHead, TableRow } from '@material-ui/core';

import { useStyles } from './styles';
import { ColumnDefinitionType } from './interfaces';
import { TableHeaderCell } from './TableHeaderCell';

type TableHeaderProps<T, K extends keyof T> = {
  columns: Array<ColumnDefinitionType<T, K>>;
};

export const TableHeader = <T, K extends keyof T>({ columns }: TableHeaderProps<T, K>) => {
  const cookies = new Cookies();
  const color = cookies.get('System-Color');
  const classes = useStyles({ color });

  return (
    <TableHead>
      <TableRow className={classes.tableHeadRow}>
        {columns.map((column) => (
          <TableHeaderCell key={column.key.toString()} column={column} />
        ))}
      </TableRow>
    </TableHead>
  );
};
